/*!
* AnalyticsTransGTMDIET.js Library v1.0.2
*
* Copyright 2017, Stefan Maris
* MIT Licensed (http://www.opensource.org/licenses/mit-license.php)
*
*
* Last update: December 5, 2017
*/
(function (root, factory) {

  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['analyticstracker'], function (analyticstracker) {
			return (root.analyticsTransGTMDIET = factory(analyticstracker, window));
		  });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory(require('analyticstracker'), window);
  } else {
    // Browser globals
    root.analyticsTransGTMDIET = factory(root.analyticstracker, window);
  }

}(this, function (analyticstracker, w) {
// UMD Definition above, do not remove this line
  'use strict';

  var _instance;

  var analyticsTransGTMDIET = function analyticsTransGTMDIET() {
    if (!(this instanceof analyticsTransGTMDIET)) {
      return new analyticsTransGTMDIET();
    }

    this.tracker = analyticstracker();
    if ((typeof w != "undefined") && (w != null)) {
      w.dataLayer = w.dataLayer || [];
    }
    this._version = "1.0.2";
    this._subscribe();
  }

  analyticsTransGTMDIET.prototype.getInstance = function() {
    if (!_instance) {
        _instance = analyticsTransGTMDIET();
    }
    return _instance;
  }

  analyticsTransGTMDIET.prototype._subscribe = function() {
    try {
      this.tracker.trackingSubscribe("GTMDIET", function (event, data) {
    		console.log("GTMDIET tracker: " + event);
      	console.log(data);
        console.log("********");
        
        /*
         * Util functions
         */
        function clone(a) {
        	return JSON.parse(JSON.stringify(a));
        }

        function isArray(obj) {
            return !!obj && obj.constructor === Array;
        }

        // check if we have an eshop an need to do GTM EE
        function isEShop (eventdata) {
            return (eventdata.hasOwnProperty("pageInfo") &&
                eventdata.pageInfo.hasOwnProperty("platform") &&
                (eventdata.pageInfo.platform == "eshop"));
        }

        // carCommerce
        function isCarCommerce(commerceObj) {
          var firstEntry = null;
          if (isArray(commerceObj)) {
            if (commerceObj.length != 0) {
              firstEntry = commerceObj[0];
            } else {
              return false;
            }
          } else {
            firstEntry = commerceObj;
          }

          return (firstEntry.hasOwnProperty("carBrand") 
                  && firstEntry.hasOwnProperty("carModel")
                  && firstEntry.carBrand !== "");
        }

         // productCommerce
         function isProductCommerce(commerceObj) {
          var firstEntry = null;
          if (isArray(commerceObj)) {
            if (commerceObj.length != 0) {
              firstEntry = commerceObj[0];
            } else {
              return false;
            }
          } else {
            firstEntry = commerceObj;
          }
          return ((firstEntry.hasOwnProperty("productName") && (firstEntry.productName !== ""))
                  || (firstEntry.hasOwnProperty("productID") && (firstEntry.productID !== "")));
        }

        // translate product based commerce (array) to EE product (array)
        function eeProdTrans(commerceObj) {
          var refArray = (isArray(commerceObj)) ? commerceObj : [commerceObj];
          var gtmPArray = [];
          for (entry of refArray) {
            var pEntry = {
              "id" : (entry.hasOwnProperty("productID")) ? entry.productID : "",
              "name" : (entry.hasOwnProperty("productName")) ? entry.productName : "",
              "price" : (entry.hasOwnProperty("productPrice")) ? entry.productPrice : 0.0,
              "brand" : (entry.hasOwnProperty("productBrand")) ? entry.productBrand : "",
              "quantity" : (entry.hasOwnProperty("productQuantity")) ? ((entry.productQuantity != "") ? entry.productQuantity : 1 ) : 1,
              "category": "",
              "variant": "",
              "list": "shop",
              "position" : 0
            }
            gtmPArray.push(pEntry);
          }
          return gtmPArray;
        }

        // translate car based commerce (array) to EE product (array)
        function eeCarTrans(commerceObj) {
          var refArray = (isArray(commerceObj)) ? commerceObj : [commerceObj];
          var gtmPArray = [];
          for (entry of refArray) {
            var pEntry = {
              "id" : (entry.hasOwnProperty("referenceID")) ? entry.referenceID : "",
              "name" : (entry.hasOwnProperty("carModel")) ? entry.carModel : "",
              "price" : (entry.hasOwnProperty("carPrice")) ? entry.carPrice : 0.0,
              "brand" : (entry.hasOwnProperty("carBrand")) ? entry.carBrand : "",
              "quantity" : 1,
              "category": "",
              "variant": (entry.hasOwnProperty("carBodyType")) ? entry.carBodyType : "",
              "list": "carshop",
              "position" : 0
            }
            gtmPArray.push(pEntry);
          }
          return gtmPArray;
        }

        function getOrderId (commerceObj) {
          var firstEntry = null;
          if (isArray(commerceObj)) {
            if (commerceObj.length != 0) {
              firstEntry = commerceObj[0];
            } else {
              return "";
            }
          } else {
            firstEntry = commerceObj;
          }
          return (firstEntry.hasOwnProperty("orderID") ? firstEntry.orderID : "");
        }

        function getOrderRevenu (commerceObj) {
          var firstEntry = null;
          if (isArray(commerceObj)) {
            if (commerceObj.length != 0) {
              firstEntry = commerceObj[0];
            } else {
              return "";
            }
          } else {
            firstEntry = commerceObj;
          }
          return (firstEntry.hasOwnProperty("orderRevenu") ? firstEntry.orderRevenu : "");
        }

        /*** End of Util functions */

        if ((typeof w != "undefined") && (w != null)) {
          // d'Ieteren customer specific translation handling
          var gtmData = {};

          switch (event) {
            case "product-impression" :
              if (data.hasOwnProperty("commerce")) {
                var cArray = [];
                if (isCarCommerce(data.commerce) && isArray(data.commerce)) {
                  // split events
                  for (var entry of data.commerce) {
                      var edata = clone(data);
                      // overwrite commerce array
                      edata.commerce = clone(entry);
                      cArray.push(edata);
                    }
                } else {
                  cArray.push(data);
                }

                for (var cItem of cArray) {
                  if (isEShop(data)) {
                    // process each event
                    if (isProductCommerce(cItem.commerce)) {
                      gtmData = clone(cItem);
                      gtmData.ecommerce = {
                        'currencyCode' : 'EUR',
                        'impressions' : eeProdTrans(cItem.commerce)
                      };
                      w.dataLayer.push(gtmData);
                    } else if (isCarCommerce(cItem.commerce)) {
                      gtmData = clone(cItem);
                      gtmData.ecommerce = {
                        'currencyCode' : 'EUR',
                        'impressions' : eeProdTrans(cItem.commerce)
                      };
                      w.dataLayer.push(gtmData);
                    } else {
                      w.dataLayer.push(cItem);
                    }
                  } else {
                    w.dataLayer.push(cItem);
                  }
                }
              } else {
                w.dataLayer.push(data);
              }
              break;

            case "product-detail":
              if (isEShop(data) && data.hasOwnProperty("commerce")) {
                if (isProductCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'detail' : {
                      'actionField' : {'list' : "shop"},
                      'products' : eeProdTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else if (isCarCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'detail' : {
                      'actionField' : {'list' : "carshop"},
                      'products' : eeCarTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else {
                  w.dataLayer.push(data);
                }
              } else {
                w.dataLayer.push(data);
              }
            break;

            case "product-click": 
              if (isEShop(data) && data.hasOwnProperty("commerce")) {
                if (isProductCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'click' : {
                      'actionField' : {'list' : "shop"},
                      'products' : eeProdTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else if (isCarCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'click' : {
                      'actionField' : {'list' : "carshop"},
                      'products' : eeCarTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else {
                  w.dataLayer.push(data);
                }
              } else {
                w.dataLayer.push(data);
              }
            break;

            case "product-addtocart": 
              if (isEShop(data) && data.hasOwnProperty("commerce")) {
                if (isProductCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'currencyCode' : 'EUR',
                    'add' : {
                      'products' : eeProdTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else if (isCarCommerce(data.commerce)) {
                  gtmData = clone(data);
                  gtmData.ecommerce = {
                    'currencyCode' : 'EUR',
                    'add' : {
                      'products' : eeCarTrans(data.commerce)
                    }
                  };
                  w.dataLayer.push(gtmData);
                } else {
                  w.dataLayer.push(data);
                }
              } else {
                w.dataLayer.push(data);
              }
            break;

            case "tool-start": 
              if (data.hasOwnProperty("info") && data.info.hasOwnProperty("toolType") && (data.info.toolType == "checkout")) {
                if (isEShop(data) && data.hasOwnProperty("commerce")) {
                  if (isProductCommerce(data.commerce)) {
                    gtmData = clone(data);
                    gtmData.ecommerce = {
                      'checkout' : {
                        'actionField' : {
                          'step': (data.info.hasOwnProperty("toolStepNumber") ? data.info.toolStepNumber : 0),
                          'option': (data.info.hasOwnProperty("toolStepOption") ? data.info.toolStepOption : "")
                          },
                        'products' : eeProdTrans(data.commerce)
                      }
                    };
                    w.dataLayer.push(gtmData);
                  } else if (isCarCommerce(data.commerce)) {
                    gtmData = clone(data);
                    gtmData.ecommerce = {
                      'checkout' : {
                        'actionField' : {
                          'step': (data.info.hasOwnProperty("toolStepNumber") ? data.info.toolStepNumber : 0),
                          'option': (data.info.hasOwnProperty("toolStepOption") ? data.info.toolStepOption : "")
                          },
                        'products' : eeCarTrans(data.commerce)
                      }
                    };
                    w.dataLayer.push(gtmData);
                  } else {
                    w.dataLayer.push(data)
                  }
                } else {
                  w.dataLayer.push(data)
                }
              } else {
                w.dataLayer.push(data);
              }
            break;

            case "tool-complete": 
              if (data.hasOwnProperty("info") && data.info.hasOwnProperty("toolType") && (data.info.toolType == "checkout")) {
                if (isEShop(data) && data.hasOwnProperty("commerce")) {
                  if (isProductCommerce(data.commerce)) {
                    gtmData = clone(data);
                    // orderID and orderRevenu are in commerce data (can be array)
                    gtmData.ecommerce = {
                      'purchase' : {
                        'actionField' : {
                          'id': getOrderId(data.commerce),
                          'revenue': getOrderRevenu(data.commerce)
                          },
                        'products' : eeProdTrans(data.commerce)
                      }
                    };
                    w.dataLayer.push(gtmData);
                  } else if (isCarCommerce(data.commerce)) {
                    gtmData = clone(data);
                    gtmData.ecommerce = {
                      'purchase' : {
                        'actionField' : {
                          'id': getOrderId(data.commerce),
                          'revenue': getOrderRevenu(data.commerce)
                          },
                        'products' : eeCarTrans(data.commerce)
                      }
                    };
                    w.dataLayer.push(gtmData);
                  } else {
                    w.dataLayer.push(data)
                  }
                } else {
                  w.dataLayer.push(data)
                }
              } else {
                w.dataLayer.push(data);
              }
            break;

            default: w.dataLayer.push(data);
            }
        }
    	});
    } catch (e) {
      console.log("GTMDIET tracker ERROR: " + e.name + ": " + e.message);
    }
  }

  _instance  = analyticsTransGTMDIET();
  return analyticsTransGTMDIET.prototype.getInstance;
}));